import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Comment, Avatar, Alert } from 'antd';
import { convertDatePtBrHs } from 'utils/dateFormatter';
import { getAuthorTitle, getAvatarImage } from './Comentario';
import * as S from './styles';

export const ComponentComentarios = ({ arrayComentario }) => {
  const user = useSelector(state => state.sefaz.userProfile);

  const getMensagem = mensagem => {
    if (mensagem?.startsWith('<')) {
      return (
        <td
          dangerouslySetInnerHTML={{
            __html: mensagem,
          }}
        />
      );
    } else {
      return <p>{mensagem}</p>;
    }
  };

  const renderAuthor = comentario => {
    return getAuthorTitle(comentario?.isAtendente, comentario?.atendente?.apelido, comentario?.setor, user);
  };

  return (
    <S.ContainerComment>
      {arrayComentario?.map(comentario => {
        const apelidoAtendente = comentario?.atendente?.apelido;
        if (!comentario?.justificativa) return <React.Fragment key={`default-${comentario?.dataInsercao}`} />;

        if (comentario?.isInfo)
          return (
            <Alert key={`isInfo-${comentario?.dataInsercao}`} message={comentario.justificativa} type="info" showIcon />
          );
        return (
          <Comment
            key={`Comment-${comentario?.dataInsercao}`}
            author={renderAuthor(comentario)}
            datetime={convertDatePtBrHs(comentario?.dataInsercao)}
            avatar={
              <Avatar
                src={getAvatarImage(comentario?.isAtendente, user)}
                alt={comentario?.isAtendente ? apelidoAtendente || 'Atendente' : 'Contribuinte'}
              />
            }
            content={getMensagem(comentario?.justificativa)}
          />
        );
      })}
    </S.ContainerComment>
  );
};

ComponentComentarios.propTypes = {
  arrayComentario: PropTypes.array,
};

ComponentComentarios.defaultProps = {
  arrayComentario: [],
};

export default ComponentComentarios;
